module.exports = __webpack_public_path__ + "13879d1a827e9889deafe4ac0a83c06e.pdf";